/**
 * Componente reutilizável para exibição de mensagens no fluxo de vinculação de perfis.
 * 
 * Este componente encapsula a renderização de mensagens informativas dentro
 * das diversas telas do processo de vinculação. Ele aceita children para permitir
 * flexibilidade no conteúdo, como elementos <p>, <strong>, ou outros componentes.
 * 
 * 
 * @param {ReactNode} children - Conteúdo a ser renderizado dentro do componente.
 *                              Geralmente contém texto explicativo, instruções ou
 *                              feedback para o usuário.
 * 
 * @param {string} className - Classes CSS a serem aplicadas ao elemento div.
 *                            As classes são normalmente provenientes do arquivo
 *                            RescueCode.module.scss e definem estilos específicos
 *                            para cada tipo de mensagem (erro, sucesso, etc).
 * 
 * Exemplo de uso:
 * <LinkMessage className={classes.successMessage}>
 *   <p>Seu perfil foi vinculado com sucesso à <strong>{nomeProfissional}</strong>.</p>
 * </LinkMessage>
 * 
 * Obs: Este componente é utilizado em todas as visualizações de estado (StateViews)
 * para manter consistência visual e facilitar alterações globais no estilo das mensagens.
 */
import classes from '../../RescueCode.module.scss';

const LinkMessage = ({ children, className }) => {
  return (
    <div className={className}>
      {children}
    </div>
  );
};

export default LinkMessage;